import api from './api';

// Teacher Management API calls
export const teachersService = {
  // Create new teacher
  createTeacher: async (teacherData) => {
    try {
      const response = await api.post('/api/teachers', teacherData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all teachers with filters
  getTeachers: async (params = {}) => {
    try {
      const response = await api.get('/api/teachers', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all teachers (alias for getTeachers)
  getAllTeachers: async (params = {}) => {
    try {
      const response = await api.get('/api/teachers', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** Trial → teaching staff + demo-ready sales; demo → demo-ready teachers and sales */
  getTeachersForSessionType: async (sessionType = 'demo') => {
    const params = {
      limit: 500,
      status: 'active',
      for_session_type: sessionType === 'trial' ? 'trial' : 'demo',
    };
    return teachersService.getAllTeachers(params);
  },

  // Get teacher by ID
  getTeacher: async (id) => {
    try {
      const response = await api.get(`/api/teachers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update teacher
  updateTeacher: async (id, updateData) => {
    try {
      const response = await api.put(`/api/teachers/${id}`, updateData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete teacher
  deleteTeacher: async (id) => {
    try {
      const response = await api.delete(`/api/teachers/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDeactivationImpact: async (id) => {
    const response = await api.get(`/api/teachers/${id}/deactivation-impact`);
    return response.data;
  },

  // Update teacher availability
  updateAvailability: async (id, availability) => {
    try {
      const response = await api.post(`/api/teachers/${id}/availability`, availability);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default teachersService; 